// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ForwardFilledSvg from "@ant-design/icons-svg/es/asn/ForwardFilled";
import AntdIcon from '../components/AntdIcon';

var ForwardFilled = function ForwardFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ForwardFilledSvg
  }));
};

ForwardFilled.displayName = 'ForwardFilled';
export default React.forwardRef(ForwardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ForwardFilled.js
// module id = 1219
// module chunks = 0